export default __webpack_public_path__ + "static/media/128x128.ddb7bc1d.jpg";